import React, { useState } from 'react';

import MAPA from '../assets/images/socios/mapa.png';
import INCF from '../assets/images/socios/INCF.png';
import PDB from '../assets/images/socios/PDB.png';
// import TSP from '../assets/images/socios/neto.png';
// import ELM from '../assets/images/socios/images.jpeg';
// import SCC from '../assets/images/socios/camp.png'; 

const CommercialClients = () => {
  const clients = [
    {
      id: 1,
      name: "Industrias Campo Fresco",
      industry: "Agroindustria",
      description: "Productores líderes en alimentos frescos y procesados.",
      logo: INCF,
      gradient: "from-blue-400 to-blue-600",
      accent: "blue"
    },
    {
      id: 2,
      name: "Pulses del Bajio",
      industry: "Agricultura",
      description: "Especialistas en producción y exportación de legumbres.",
      logo: PDB,
      gradient: "from-emerald-400 to-emerald-600",
      accent: "emerald"
    },
    // {
    //   id: 3,
    //   name: "Tiendas Super Precio",
    //   industry: "Retail",
    //   description: "Cadena de supermercados con presencia nacional.",
    //   logo: TSP,
    //   gradient: "from-purple-400 to-purple-600",
    //   accent: "purple"
    // },
    // {
    //   id: 4,
    //   name: "Empacadora la Merced",
    //   industry: "Logística",
    //   description: "Empacadora y distribuidora de productos agrícolas.",
    //   logo: ELM,
    //   gradient: "from-orange-400 to-orange-600",
    //   accent: "orange"
    // },
    // {
    //   id: 5,
    //   name: "Semillas y Cereales el Campesino",
    //   industry: "Agrotecnología",
    //   description: "Innovación en semillas y desarrollo agrícola.",
    //   logo: SCC,
    //   gradient: "from-red-400 to-red-600",
    //   accent: "red"
    // }
  ];

  const [selected, setSelected] = useState(clients[0]);

  return (
    <div className="py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Fondo MAPA con blur y opacidad */}
      <div
        className="absolute inset-0 w-full h-full z-0 pointer-events-none"
        style={{
          backgroundImage: `url(${MAPA})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          filter: 'brightness(1.05) contrast(0.98)',
          opacity: 0.85
        }}
      />
      <div className="max-w-4xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Nuestros Clientes Comerciales
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Colaboramos con empresas líderes en diversas industrias, 
            brindando soluciones innovadoras y estableciendo alianzas estratégicas duraderas.
          </p>
        </div>
        {/* Card principal del socio seleccionado */}
        <div className="bg-white bg-opacity-90 rounded-3xl shadow-lg p-10 flex flex-col md:flex-row items-center gap-8 mb-10 border border-green-100 min-h-[340px]">
          <div className="flex-shrink-0 flex items-center justify-center w-56 h-56 bg-white rounded-2xl shadow-md">
            <img
              src={selected.logo}
              alt={selected.name + ' logo'}
              style={{maxWidth: '220px', maxHeight: '220px', objectFit: 'contain', borderRadius: '24px', background: 'white', padding: '12px'}}
            />
          </div>
          <div className="flex-1 text-left">
            <h2 className="text-3xl font-bold text-gray-900 mb-2">{selected.name}</h2>
            <p className="text-lg text-gray-600 mb-4">{selected.description}</p>
            <span className="inline-block px-5 py-2 rounded-full text-base font-semibold bg-orange-500 text-white mb-2">Socio Estratégico</span>
            <div className="flex gap-8 mt-4">
              <div>
                <div className="text-sm text-gray-500">Industria</div>
                <div className="text-base font-bold text-gray-800">{selected.industry}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Selector de socios comerciales */}
        <div className="flex gap-6 justify-center mb-16">
          {clients.map((client) => (
            <button
              key={client.id}
              onClick={() => setSelected(client)}
              className={`group bg-white rounded-2xl shadow-sm border transition-all duration-200 flex items-center justify-center w-48 h-36 px-2 py-2 focus:outline-none ${selected.id === client.id ? 'border-green-400 shadow-lg' : 'border-gray-200 opacity-60 hover:opacity-100'}`}
              aria-label={client.name}
            >
              <img
                src={client.logo}
                alt={client.name + ' logo'}
                style={{maxWidth: '120px', maxHeight: '80px', objectFit: 'contain', borderRadius: '12px', background: 'white', padding: '6px'}}
                className={selected.id === client.id ? '' : 'grayscale'}
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CommercialClients;